import { Subtext } from '@workday/canvas-kit-react/text';
import { WcpStyles } from '@workday/wcp-tokens';
import React, { ElementType } from 'react';

export const ThemedSubtext = ({ as = 'p', ...props }: React.ComponentProps<typeof Subtext> & { as?: ElementType }) => {
  return <Subtext color={WcpStyles.color.text.default} as={as} {...props} />;
};
